import script from "./Attachements.vue?vue&type=script&lang=ts&setup=true"
export * from "./Attachements.vue?vue&type=script&lang=ts&setup=true"

import "./Attachements.vue?vue&type=style&index=0&id=0f96b6b4&scoped=true&lang=css"
import "./Attachements.vue?vue&type=style&index=1&id=0f96b6b4&lang=css"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f96b6b4"]])

export default __exports__